module.exports = __webpack_public_path__ + "static/media/new-logosjcoc.36512a16.png";